import React, { useState } from "react";
import "./Nav.css";

export default function Nav() {
  const [openSearch, setOpenSearch] = useState(false);

  return (
    <header className="vt-navbar">
      <div className="vt-navbar__container">
        {/* Logo */}
        <a href="/" className="vt-navbar__logo">
          <img
            style={{ width: "80px", height: "80px" }}
            src="/logo.png"
            alt="ruttienthetindung"
          />
        </a>

        {/* Search desktop */}
        <div className="vt-navbar__search vt-navbar__search--desktop">
          <input type="text" placeholder="Nhập từ khóa..." />
          <button type="button" className="vt-navbar__search-btn">
            <SearchIcon />
            <span>Tìm kiếm</span>
          </button>
        </div>

        {/* Hotline desktop */}
        <a href="tel:0867529641" className="vt-navbar__hotline">
          <span className="vt-navbar__hotline-icon">
            <PhoneIcon />
          </span>
          <span className="vt-navbar__hotline-text">
            <small>HOTLINE KINH DOANH</small>
            <strong>0994 306 219</strong>
          </span>
        </a>
        <a href="privacy" className="vt-navbar__hotline">
          <span className="vt-navbar__hotline-text">
            <strong>Chính sách bảo mật</strong>
          </span>
        </a>

        {/* Mobile actions */}
        <div className="vt-navbar__mobile-actions">
          <button
            type="button"
            className="vt-navbar__icon-btn"
            aria-label="Mở tìm kiếm"
            onClick={() => setOpenSearch(!openSearch)}
          >
            <SearchIcon />
          </button>

          <a
            href="tel:0867529641"
            className="vt-navbar__icon-btn vt-navbar__icon-btn--phone"
            aria-label="Gọi hotline"
          >
            <PhoneIcon />
          </a>
        </div>
      </div>

      {/* Search mobile dropdown */}
      <div className={`vt-navbar__mobile-search ${openSearch ? "active" : ""}`}>
        <div className="vt-navbar__mobile-search-inner">
          <input type="text" placeholder="Nhập từ khóa..." />
          <button type="button">
            <SearchIcon />
          </button>
        </div>
      </div>
    </header>
  );
}

function SearchIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="18"
      height="18"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="7" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.33 1.78.63 2.61a2 2 0 0 1-.45 2.11L8 9.91a16 16 0 0 0 6.09 6.09l1.47-1.29a2 2 0 0 1 2.11-.45c.83.3 1.71.51 2.61.63A2 2 0 0 1 22 16.92z" />
    </svg>
  );
}
